/* global AuEmbed */

// Wrapper for the AB Testing in coffee
const abTesting = {
  /**
   * @type {function}
   * @returns {Object} { `experiment_name`: `experiment_version` }
   */
  getRunningExperiments: () => window.AuEmbed.AbTesting.getRunningExperiments(),
}

export default abTesting
